import React, { useState, useEffect, useContext } from "react";
import "./searchRequisitions.css";

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate  } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import AddRequisition from "../../components/Icons/addrequisition";
import "react-datepicker/dist/react-datepicker.css";
import getAllRequisitionStatus from "../../apis/getallRequisitionStatus/getAllRequisitionStatus";
import RequisitionListCard from "../../components/RequisitionsList/RequisitionListCard";
import getAllRecruiterLeader from "../../apis/getAllRecruiterLeader/getAllRecruiterLeader";
import { getClientByOrg } from "../../apis/organisationAdminAPI/manageClient";
import Tooltip  from "@mui/material/Tooltip";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
import { UserTypeContext } from "../../AppRoute";


const SearchRequisitions = (props) => {
    const location = useLocation();  
    const history = useNavigate ();
    const { userType, userRecords } = useContext(UserTypeContext);
    const idContextTest = location?.state?.id ? location?.state?.id : userRecords?.id;
    const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
    const userRecruitmentpartnerId = location?.state?.userRecruitmentpartnerId ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;

    const [requisitionStatus, setRequisitionStatus] = useState([]);
    const [recruitmentLeaders, setRecruitmentLeaders] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [allClient, setAllClient] = useState([]);
    const [subStatus, setSubStatus] = useState("");
    const [currentStatusCode, setCurrentStatusCode] = useState("");
    const [keywordOptions, setKeywordOptions] = useState([])
    const [keywordCurrentValue, setKeywordCurrentValue] = useState("")
    const [searchComplete, setSearchComplete] = useState(true)
    const jsonConfig = require("../../Config.json");

    const [searchpayload, setSearchPayload] = useState({
        keywords: [],
        assignedTo: "",
        priority: "",
        createdOn_from: "",
        createdOn_to: "",
        clientId: "",
        updatedOn_from: "",
        updatedOn_to: "",
        status: "",
        subStatus: ""
    })


    const keywordValuechangeHandler = (e, value) => {
        setSearchPayload(prev => ({
            ...prev,
            keywords: value
        }))
        setKeywordOptions([])
    }

    const keywordTextFieldChange = (e) => {
        setKeywordCurrentValue(e.target.value)
        let arr = [];
        arr.push(e.target.value)
        setKeywordOptions(arr)
    }

    const filterChange = (newValue, val) => {
        if (val) {
            if (newValue === "status") {
                setCurrentStatusCode(val?.statusCode);
                setSearchPayload(prev => ({
                    ...prev,
                    [newValue]: val._id // Toggle the value of the clicked filter
                }));
            }
            else if (newValue === "subStatus") {
                let substatusCode = val === "COVERED" ? jsonConfig.requisitionStatusCodes.OPENSUBSTATUS.COVERED : val === "UNCOVERED" ? jsonConfig.requisitionStatusCodes.OPENSUBSTATUS.UNCOVERED : jsonConfig.requisitionStatusCodes.OPENSUBSTATUS.UNASSIGNED;
                setSubStatus(val);
                setSearchPayload(prev => ({
                    ...prev,
                    [newValue]: substatusCode // Toggle the value of the clicked filter
                }));
            }
            else {
                setSearchPayload(prev => ({
                    ...prev,
                    [newValue]: val // Toggle the value of the clicked filter
                }));
            }
        }
        else {
            if (newValue === "status") {
                setCurrentStatusCode("");
            }
            else if (newValue === "subStatus") {
                setSubStatus("");
            }
            setSearchPayload(prev => ({
                ...prev,
                [newValue]: "" // Toggle the value of the clicked filter
            }))
        }
    };

    const getReqStatus = async () => {
        try {
            const res = await getAllRequisitionStatus();
            setRequisitionStatus(res.data.data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        let isMounted = true;
        const getAllClientData = async () => {
            let payload = {
                recruitmentPartnerId: userRecruitmentpartnerId,
                isActive: true
            }
            let res = await getClientByOrg(payload);
            if (isMounted) {
                setAllClient(res.data.data);
            }
        }

        const getAllrecruitmentLeadersData = async () => {
            const res = await getAllRecruiterLeader({ recruitmentPartnerId: userRecruitmentpartnerId });
            if (isMounted) {
                setRecruitmentLeaders(res.data.data);
            }
        }

        getReqStatus();
        getAllrecruitmentLeadersData()
        getAllClientData()

        return () => {
            isMounted = false;
        };

    }, [userRecruitmentpartnerId, userType, userRole, userRecords]);

    const goToDahboard = () => {
        if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
            history("/requisition-dashboard",
                {state: { id: idContextTest, recruitementPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
            });
        } else {
            history("/dashboard",
                {state: {
                    id: idContextTest, roleName: userRole, recruitmentPartnerId: userRecruitmentpartnerId, userRecords: userRecords
                }
            });
        }
    }

    const goToCreateReq = () => {
        history("/create-requisition");
    }

    return (
        <>
        {
            userType !== "Candidate" ? (<div className="mainDiv_advanceSearch">
                <div className="titleContainer">
                    <div className="community_header">
                        <div className="go_back_button" onClick={(e) => goToDahboard()}>
                            <Tooltip title={userType === "MIS Operator" ? "Go Back to Requisition Dashboard" : "Go Back to Dashboard"} placement="bottom">
                                <ArrowBackIcon sx={{ fontSize: 20 }} />
                            </Tooltip>
                            {/* <span>&nbsp;Go Back to Dashboard</span> */}
                        </div>
                        <div className="communityTitle">Requisitions</div>
                    </div>
                    

                    {userType === "MIS Operator" ?
                        <div className="addReq_button">
                            <Button className="add_req_button_req" onClick={(e) => goToCreateReq()}>
                                <AddRequisition height={18} width={18} color="#ffffff"  alt="AddRequisition_Icon" />
                                &nbsp;
                                Add Requisitions
                            </Button>
                        </div>
                        : null}
                </div>

                <div className="mainContentContainer_advanceSearch">
                    <div className="filterContainer_advanceSearch_candidate">
                        <div className="topSection_searchFilter">
                            <div className="firstDiv_topSection">
                                <span className='showingRF'>Search Requisitions</span>
                            </div>
                            <div>
                                {
                                    searchComplete ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className="searchButton"
                                            onClick={(e) => {
                                                setIsSearching(!isSearching)
                                                setSearchComplete(false)
                                            }}
                                            disabled={!searchComplete}
                                        >
                                            Search
                                        </Button>
                                    ) : (
                                        <Button
                                            disabled={!searchComplete}
                                        >
                                            <div className="btn_loader">
                                                Searching
                                                &nbsp;
                                                {!searchComplete && (
                                                    <div>
                                                        <CircularProgress size={14} />
                                                    </div>
                                                )}
                                            </div>
                                        </Button>
                                    )
                                }
                            </div>
                        </div>

                        <div className="filterSection_advanceSearch_req">
                            <div className="search_Container_advanceSearch">
                                <span className='filterItemTitle'>Search Keywords</span>
                            <div className="inputItemsContainer">
                                <Autocomplete
                                    id="tags-filled"
                                    freeSolo
                                    multiple
                                    filterSelectedOptions
                                    className='searchreq_autocom mt_10'
                                    options={keywordOptions}
                                    value={searchpayload.keywords}
                                    onChange={keywordValuechangeHandler}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                        <TextField {...params}
                                            variant='outlined'
                                            value={keywordCurrentValue}
                                            onChange={(e) => keywordTextFieldChange(e)}
                                            placeholder="Enter keywords" />
                                    )}
                                />
                                
                            </div>
                            </div>

                            {userType === "MIS Operator" || userType === "Organization Admin" ? (
                                <div className="search_Container_advanceSearch">
                                    <span className='filterItemTitle'>Assigned To</span>
                                    <Autocomplete
                                        id="free-solo-2-demo"
                                        options={recruitmentLeaders}
                                        className='searchreq_autocom mt_10'
                                        filterSelectedOptions
                                        getOptionLabel={(option) => option.email || ""}
                                        onChange={(e, val) => filterChange("assignedTo", val?.id || "")}
                                        PaperComponent={({ children }) => (
                                            <Paper
                                                style={{ fontSize: "14px", fontFamily: 'Segoe UI' }}
                                            >
                                                {children}
                                            </Paper>
                                        )}
                                        value={recruitmentLeaders.filter((option) => option.id === searchpayload.assignedTo)[0] || ""}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                placeholder='Select Recruitment Leader'
                                                variant="outlined"
                                            />}
                                    />
                                    
                                </div>
                            ) : null}

                            <div className="search_Container_advanceSearch">
                                <span className='filterItemTitle'>Priority</span>
                                <Autocomplete
                                    id="free-solo-2-demo"
                                    options={["High", "Low"]}
                                    className='searchreq_autocom mt_10'
                                    filterSelectedOptions
                                    value={searchpayload.priority}
                                    getOptionLabel={(option) => option || ""}
                                    onChange={(e, val) => filterChange("priority", val || "")}
                                    PaperComponent={({ children }) => (
                                        <Paper
                                            style={{ fontSize: "14px", fontFamily: 'Segoe UI' }}
                                        >
                                            {children}
                                        </Paper>
                                    )}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder='Select Priority'
                                            variant="outlined"
                                        />}
                                />
                                
                            </div>

                                    {currentStatusCode !== jsonConfig.requisitionStatusCodes.OPEN ?
                                        <div className="search_Container_advanceSearch">
                                            <span className='filterItemTitle'>Status</span>
                                            <Autocomplete
                                                id="free-solo-2-demo"
                                                options={requisitionStatus}
                                                className='searchreq_autocom mt_10'
                                                filterSelectedOptions
                                                value={requisitionStatus.filter((option) => option._id === searchpayload.status)[0] || ""}
                                                getOptionLabel={(option) => option.name || ""}
                                                onChange={(e, val) => filterChange("status", val || "")}
                                                PaperComponent={({ children }) => (
                                                    <Paper
                                                        style={{ fontSize: "14px", fontFamily: 'Segoe UI' }}
                                                    >
                                                        {children}
                                                    </Paper>
                                                )}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        placeholder='Requisition Status'
                                                        variant="outlined"
                                                    />}
                                            />
                                            
                                        </div>
                                        :
                                        <div className='searec_employementContainer'>
                                            <div className='searec_employmentItems'>
                                                <span className='filterItemTitle'>Status</span>
                                                <Autocomplete
                                                    id="free-solo-2-demo"
                                                    options={requisitionStatus}
                                                    className='employementAutocomplete mt_10'
                                                    value={requisitionStatus.filter((option) => option._id === searchpayload.status)[0] || ""}
                                                    onChange={(e, val) => filterChange("status", val || "")}
                                                    getOptionLabel={(option) => option.name || ""}
                                                    PaperComponent={({ children }) => (
                                                        <Paper
                                                            style={{ fontSize: "13px", fontFamily: 'Segoe UI', textWrap: "wrap" }}
                                                        >
                                                            {children}
                                                        </Paper>
                                                    )}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            placeholder='Requisition Status'
                                                            variant="outlined"
                                                        />}
                                                />
                                            </div>
                                            <div className='searec_employmentItems'>
                                                <span className='filterItemTitle'>Sub Status</span>
                                                <Autocomplete
                                                    id="free-solo-2-demo"
                                                    options={(userType === 'Recruiter' || (userType === 'Admin' && userRole === "Recruiter")) ? ['COVERED', 'UNCOVERED'] : ['COVERED', 'UNCOVERED', 'UNASSIGNED']}
                                                    className='employementAutocomplete mt_10'
                                                    value={subStatus}
                                                    onChange={(e, val) => filterChange("subStatus", val || "")}
                                                    getOptionLabel={(option) => option || ""}
                                                    PaperComponent={({ children }) => (
                                                        <Paper
                                                            style={{ fontSize: "13px", fontFamily: 'Segoe UI', textWrap: "wrap" }}
                                                        >
                                                            {children}
                                                        </Paper>
                                                    )}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            placeholder='Select Substatus'
                                                            variant="outlined"
                                                        />}
                                                />
                                            </div>
                                        </div>}

                                    <div className="search_Container_advanceSearch">
                                        <span className='filterItemTitle'>Client</span>
                                        <Autocomplete
                                            id="free-solo-2-demo"
                                            options={allClient}
                                            className='searchreq_autocom mt_10'
                                            filterSelectedOptions
                                            value={allClient.filter((option) => option._id === searchpayload.clientId)[0] || ""}
                                            getOptionLabel={(option) => option.clientName || ""}
                                            onChange={(e, val) => filterChange("clientId", val?._id || "")}
                                            PaperComponent={({ children }) => (
                                                <Paper
                                                    style={{ fontSize: "14px", fontFamily: 'Segoe UI' }}
                                                >
                                                    {children}
                                                </Paper>
                                            )}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    placeholder='Select Client'
                                                    variant="outlined"
                                                />}
                                        />
                                        
                                    </div>

                                    <div className="search_Container_advanceSearch datePicker_SearchReequisition">
                                        <span className='filterItemTitle'>Created On</span>
                                        <div className="mt_10"></div>
                                        <div className="seareq-date-picker">
                                            <div>
                                                <DatePicker
                                                    className="seareq_date_border"
                                                   
                                                    selected={searchpayload.createdOn_from ? new Date(searchpayload.createdOn_from) : ""}
                                                    onChange={(date) => filterChange("createdOn_from", date)}
                                                    placeholderText="Select Date"
                                                />
                                            </div>
                                            <div className='filterItemTitle seareq_datePicker'>To</div>
                                            <div>
                                                <DatePicker
                                                    className="seareq_date_border"
                                                    
                                                    selected={searchpayload.createdOn_to ? new Date(searchpayload.createdOn_to) : ""}
                                                    onChange={(date) => filterChange("createdOn_to", date)}
                                                    placeholderText="Select Date"
                                                />
                                            </div>
                                        </div>
                                       
                                    </div>

                                    <div className="search_Container_advanceSearch datePicker_SearchReequisition">
                                        <span className='filterItemTitle'>Updated On</span>
                                        <div className="mt_10"></div>
                                        <div className="seareq-date-picker">
                                            <div>
                                                <DatePicker
                                                    className="seareq_date_border"
                                                    
                                                    selected={searchpayload.updatedOn_from ? new Date(searchpayload.updatedOn_from) : ""}
                                                    onChange={(date) => filterChange("updatedOn_from", date)}
                                                    placeholderText="Select Date"
                                                />
                                            </div>
                                            <div className='filterItemTitle seareq_datePicker'>To</div>
                                            <div>
                                                <DatePicker
                                                    className="seareq_date_border"
                                                    
                                                    selected={searchpayload.updatedOn_to ? new Date(searchpayload.updatedOn_to) : ""}
                                                    onChange={(date) => filterChange("updatedOn_to", date)}
                                                    placeholderText="Select Date"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <RequisitionsList /> */}
                            <div className="search-results-container">
                                <RequisitionListCard
                                    searchpayload={searchpayload}
                                    isSearching={isSearching}
                                    idContextTest={idContextTest}
                                    userType={userType}
                                    userRecruitmentpartnerId={userRecruitmentpartnerId}
                                    requisitionStatus={requisitionStatus}
                                    isSearchRequisition={true}
                                    userRole={userRole}
                                    setSearchComplete={setSearchComplete}
                                    userRecords={userRecords}
                                />
                            </div>

                            {/* </card> */}
                        </div>
                    </div>) : <UnauthorizedAccess/>
        }
            
                
        </>
    )
}

export default SearchRequisitions;